import { render } from "./OnboardingCustom.vue?vue&type=template&id=e67c162e"
import script from "./OnboardingCustom.vue?vue&type=script&lang=js"
export * from "./OnboardingCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__